// extracted by mini-css-extract-plugin
export var notificationHost = "_g7-0";